import { render, staticRenderFns } from "./RemoteSelect.vue?vue&type=template&id=5377d260&scoped=true&"
import script from "./RemoteSelect.vue?vue&type=script&lang=js&"
export * from "./RemoteSelect.vue?vue&type=script&lang=js&"
import style0 from "./RemoteSelect.vue?vue&type=style&index=0&id=5377d260&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377d260",
  null
  
)

export default component.exports